export const substituteVariables = (text, variablesIn) => {
    if (!text) {
        return "";
    }
    let substitutedText = text;
    console.log(variablesIn);
    if (variablesIn) {
        const variables = (typeof variablesIn === "string") ? JSON.parse(variablesIn) || {} : variablesIn;
        Object.keys(variables).forEach((variableName) => {
            // handle special characters in variable name
            const variableForRegex = variableName.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
            const regex = new RegExp('{' + variableForRegex + '}', 'g');
            substitutedText = substitutedText.replace(regex, variables[variableName]);
        });
    }
    // Remove any variables that were not substituted from inputs
    substitutedText = substitutedText.replace(/{[^{}]+}/g, '');
    return substitutedText;
};
export const validateVariables = (value, schema) => {
    if (schema.variables.length === 0) {
        return true;
    }
    let values;
    try {
        values =
            typeof value === "string"
                ? value
                    ? JSON.parse(value)
                    : {}
                : value;
    }
    catch (e) {
        throw new SyntaxError(`[@pdfme/generator] invalid JSON string '${value}' for variables in field ${schema.name}`);
    }
    for (const variable of schema.variables) {
        const v = values[variable];
        if (v === undefined || v === null) {
            if (schema.required) {
                throw new Error(`[@pdfme/generator] variable ${variable} is missing for field ${schema.name}`);
            }
            // Variable fehlt → optional → rendern trotzdem erlauben
            continue;
        }
    }
    return true;
};
//# sourceMappingURL=helper.js.map